// Platform marks for the desktop download buttons. Inline, single-colour
// (currentColor), so they follow the button's text colour in every state.
type P = { className?: string };

export function AppleIcon({ className = "h-4 w-4" }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M16.37 12.62c-.02-2.13 1.74-3.15 1.82-3.2-1-1.45-2.54-1.65-3.08-1.67-1.31-.13-2.56.77-3.22.77-.67 0-1.69-.75-2.78-.73-1.43.02-2.75.83-3.48 2.11-1.49 2.58-.38 6.39 1.07 8.48.71 1.02 1.55 2.17 2.65 2.13 1.07-.04 1.47-.69 2.75-.69 1.29 0 1.65.69 2.78.67 1.15-.02 1.87-1.04 2.57-2.07.81-1.18 1.14-2.33 1.16-2.39-.03-.01-2.22-.85-2.24-3.41ZM14.27 6.36c.58-.71.98-1.69.87-2.67-.84.03-1.86.56-2.46 1.27-.54.62-1.01 1.62-.89 2.58.94.07 1.9-.48 2.48-1.18Z" />
    </svg>
  );
}

export function WindowsIcon({ className = "h-4 w-4" }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M3 5.1 10.4 4v7.2H3V5.1Zm8.3-1.24L21 2.5v8.7h-9.7V3.86ZM3 12.4h7.4v7.2L3 18.5v-6.1Zm8.3 0H21v8.7l-9.7-1.36V12.4Z" />
    </svg>
  );
}
